<div class="row">
  <div class="col-12">
    <sb-card [singleHeight]="true">
      <div card-header>
        <h3>{{ 'nav.network.networkAllocation' | translate }}</h3>
        <small>{{ getInfoText() }}</small>
      </div>
      <div card-header-more>
        <div class="tw-flex tw-items-center tw-gap-2 tw-mb-2">
          <sb-toggle class="" [toggleLabel]="'Aggregation'" [checked]="useAggregated"
                     (valueChange)="changeAggregationUsage($event)"></sb-toggle>
          <div>
            <div class="tw-flex tw-gap-2">
              <sb-local-date-time-input [ngClass]="{'alertbox': from && till && from?.value > till?.value}" [initialDate]="from"
                                        [title]="'lang.dateRange.from' |translate"
                                        (modelChange)="changeFrom($event)"></sb-local-date-time-input>
              <sb-local-date-time-input class="" (modelChange)="changeTill($event)"
                                        [title]="'lang.dateRange.to' |translate"
                                        [initialDate]="till"></sb-local-date-time-input>
            </div>
            <div *ngIf="from && till && from?.value > till?.value" class="alert alert-danger"
                 style="font-size: .7rem;">{{ 'lang.globals.dateWarning'|translate }}
            </div>
          </div>


          <sb-comp-dropdown-select
            *ngPermissions="permissionService.Permission.planning_list"
            [singleSelectMode]="true" [showSubmit]="false"
            [inputData]="plannings" [dropDownDatatype]="'PLANNINGS'"
            (selectedDataEmitter)="update($event, 'PLANNINGS')" [showColumnIcon]="false"
            [msOptions]="msPlanningOptions" (msOptionsChange)="msRequest('PLANNINGS', $event)"
            [selectedInputData]="filteredPlanning ? [filteredPlanning] : []">
          </sb-comp-dropdown-select>
          <sb-comp-dropdown-select
            *ngPermissions="permissionService.Permission.cull_list"
            [inputData]="culls" [dropDownDatatype]="'PLAYER_CULLS'"
            (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
            [msOptions]="msCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
            [selectedInputData]="filteredCulls?.length> 0  ? filteredCulls: []">
          </sb-comp-dropdown-select>


          <sb-comp-dropdown-select
            [inputData]="advertisers" [dropDownDatatype]="'ADVERTISERS'"
            (selectedDataEmitter)="update($event, 'ADVERTISERS')" [showColumnIcon]="false"
            [msOptions]="msAdvertiserOptions" (msOptionsChange)="msRequest('ADVERTISERS', $event)"
            [selectedInputData]="filteredAdvertisers?.length>0 ? filteredAdvertisers : []">
          </sb-comp-dropdown-select>
          <sb-comp-dropdown-select
            *ngPermissions="permissionService.Permission.location_list"
            [inputData]="locations" [dropDownDatatype]="'LOCATIONS'"
            (selectedDataEmitter)="update($event, 'LOCATIONS')" [showColumnIcon]="false"
            [msOptions]="msLocationOptions" (msOptionsChange)="msRequest('LOCATIONS', $event)"
            [selectedInputData]="filteredLocations?.length>0 ? filteredLocations : []">
          </sb-comp-dropdown-select>
          <sb-comp-dropdown-select
            *ngPermissions="permissionService.Permission.location_list"
            [inputData]="channels" [dropDownDatatype]="'CHANNELS'"
            (selectedDataEmitter)="update($event, 'CHANNELS')" [showColumnIcon]="false"
            [msOptions]="msChannelOptions" (msOptionsChange)="msRequest('CHANNELS', $event)"
            [selectedInputData]="filteredChannels?.length>0 ? filteredChannels : []">
          </sb-comp-dropdown-select>

          <div class="">
            <input id="screen-box" type="text" class="form-control" placeholder="{{'lang.globals.screen' | translate}}"
                   [(ngModel)]="screen" />
          </div>
          <div class="">
            <input id="device-box" type="text" class="form-control" placeholder="{{'lang.globals.device' | translate}}"
                   [(ngModel)]="device" />
          </div>
          <button (click)="refresh()" [disabled]="((from !== null) !== (till !== null)) || (till?.value < from?.value)"
                  class="cursor-pointer btn btn-primary">
            <sb-icon icon="pieChartStake" class="mr-1"></sb-icon>
            {{ 'lang.globals.show' | translate }} &nbsp;
          </button>
        </div>
      </div>
    </sb-card>
    <div class="tw-flex tw-flex-col tw-gap-2">
      @if (loading) {
        @if (loadingNetworkAccess) {
          <sb-loading-spinner></sb-loading-spinner>
        } @else {
          <sb-comp-shared-network-access [sharedNetworkAccesses]="sharedNetworkAccess"></sb-comp-shared-network-access>
        }
        @if (loadingSetlist) {
          <sb-loading-spinner></sb-loading-spinner>
        } @else {
          <sb-comp-setlist-view [sharedSetlists]="sharedSetlists"></sb-comp-setlist-view>
        }
        @if (loadingPlaybackSchedule) {
          <sb-loading-spinner></sb-loading-spinner>
        } @else {
          <sb-comp-shared-playback-schedules [sharedPlaybackSchedules]="sharedPlaybackSchedules"></sb-comp-shared-playback-schedules>
        }
        @if (loadingContentShare) {
          <sb-loading-spinner></sb-loading-spinner>
        } @else {
          <sb-comp-shared-content-shares [sharedContentShares]="sharedContentShares"></sb-comp-shared-content-shares>
        }
        @if (loadingPlaylist) {
          <sb-loading-spinner></sb-loading-spinner>
        } @else {
          <sb-comp-playlist-view [sharedPlaylists]="sharedPlaylists" [aggregated]="useAggregated"></sb-comp-playlist-view>
        }
      }
    </div>
  </div>
</div>
